declare var $ :any;
export class questionConfig {
	questionList: any = {
		"qst1": {
			id: 1,
			pageRules: {
				"0": function(hotelObj) {
					hotelObj.currentQuestion.id = 1;
					hotelObj.optionSelectedIndex = -1;
					hotelObj.gotoMultiChoice();
				},
				"1": function(hotelObj) {
					//hotelObj.moveToHistory(0)
					hotelObj.currentIndex = 20;
					hotelObj.dialogueStep = 1;
					hotelObj.onUnlock();
					hotelObj.dialogueAnimations(1);
				},
				"2": function(hotelObj) {
					hotelObj.dialogueStep = 1;
					//增加5段对话
					hotelObj.dialogueAnimations(5);
					$("#step5-dialogue-list").hide();
					hotelObj.currentIndex = 20;
					hotelObj.onUnlock();
				}
			}
		},
		"qst2": {
			id: 2,
			pageRules: {
				"default": function(hotelObj) {
					$("#single-choice").hide();
					hotelObj.selectedMutliChoice = {};
					hotelObj.currentQuestion = {
						id: 3,
						title: "根据你期望的结果和标准，界定现在最需要处理的问题是？",
						type: "单选题",
						sub: 1,
						options: [
							"应对酒店淡季，设计有特色的促销方案，提升销量",
							"提升酒店的客户体验流程，增加客户转化率及粘性",
							"怎样处理员工的问题，保证在接待VVIP客户团时人手不短缺，服务质量不下降"
						]
					};
					hotelObj.optionSelectedIndex = -1;

					$(".choice-title").html(hotelObj.currentQuestion.title);
					setTimeout(function() {
						hotelObj.showQuestionDialogue(1);
					}, 200);
				}
			}
		},
		"qst3": {
			id: 3,
			pageRules: {
				"default": function(hotelObj) {
					$("#single-choice").hide();
					hotelObj.selectedMutliChoice = {};
					hotelObj.currentQuestion = {
						id: 4,
						title: "基于所期望的结果，你觉得衡量标准是什么？",
						type: "多选题",
						sub: 2,
						options: [
							"控制成本，不要有太多花销",
							"达到今年自己和整个团队的KPI指标",
							"客户满意度在下个月上升至95%",
							"团队士气保持高位，激励措施到位",
							"在一个月内看到员工行动上的改变，保证个人绩效达标",
							"市场的反馈良好",
							"各部门配合与响应速度超过行业平均标准",
							"保证自己团队的稳定性，使提供的服务和销售质量不受到影响",
							"处理员工问题要保证公平公正，兼顾对团队其他成员的影响",
							"团队及跨部门伙伴对方案的接受度高",
							"方案的执行较为容易，实施计划不复杂"
						]
					};
					hotelObj.optionSelectedIndex = -1;
					$(".choice-title").html(hotelObj.currentQuestion.title);
					setTimeout(function() {
						hotelObj.showQuestionDialogue(1);
					}, 200);
				}
			}
		},
		"qst4": {
			pageRules: {
				"default": function(hotelObj, qstId) {
					hotelObj.optionSelectedIndex = -1;
					hotelObj.currentQuestion = {
						id: 5,
						title: "恭喜你，顺利地找到自己要处理的问题。接下来，需要思考的是如何找到解决问题所需的信息。试试看，你会怎么做呢？",
						type: "单选题",
						sub: 1,
						options: [
							"唔，要是信息能再多一点就好了，要不我再问问别人？",
							"天呐，时间来不及了，还是赶紧先把可行性方案做出来吧。"
						]
					};
					$("#wrap").hide().addClass("bg3").fadeIn();
					$("#mindyicon").show();
					$("#tipText").html(hotelObj.currentQuestion.title);
					$("#choiceTip").show();
					$(".choice-title").html("");
					$("#single-choice").hide();
					$("#single-choice").addClass("single-choice-small");
					$("#single-choice").show();
				}
			}
		},
		"qst5": {
			pageRules: {
				"default": function(hotelObj, qstId, answer) {
					//跳转下一题
					$("#single-choice").removeClass().addClass("fontSize16");
					$("#mindyicon").hide();
					$("#choiceTip").hide();

					$("#step5-dialogue-list").hide();
					//邮件
					$("#emailicon").show();
					$("#emailunreader").show();
					//短信
					$("#messageicon").show();
					$("#messageunreader").show();

					//隐藏单选框
					$("#single-choice").hide();

					//选择B得1分
					if(1 == answer) {
						//选B跳转到选方案
						hotelObj.currentIndex = 31;
						hotelObj.onUnlock();
						return;
					}else{
						hotelObj.currentIndex = 21;
					}

					//剧情下跳
					hotelObj.showSkipTip();
				}
			}
		},
		"qst6": {
			pageRules: {
				"0": function(hotelObj, qstId) {
					$("#single-choice").removeClass().addClass("fontSize16");
					$("#mindyicon").hide();
					$("#choiceTip").hide();
					$("#single-choice").hide();
					hotelObj.currentIndex = 31;
					hotelObj.onUnlock();
				},
				"1": function(hotelObj, qstId) {
					$("#single-choice").removeClass().addClass("fontSize16");
					$("#mindyicon").hide();
					$("#choiceTip").hide();
					$("#single-choice").hide();
					hotelObj.currentIndex = 23;
					hotelObj.onUnlock();
				},
				"2": function(hotelObj, qstId) {
					$("#single-choice").removeClass().addClass("fontSize16");
					$("#mindyicon").hide();
					$("#choiceTip").hide();
					$("#single-choice").hide();
					hotelObj.currentIndex = 27;
					hotelObj.onUnlock();
				}
			}
		},
		"qst7": {
			pageRules: {
				"default": function(hotelObj, qstId, answer) {
					hotelObj.optionSelectedIndex = 1;
					hotelObj.currentQuestion = {
						id: 8,
						title: "苦思冥想过后，你已经挑选好了需要的信息，请为它们排个序吧。",
						type: "排序题",
						sub: 4,
						options: [
							"客户满意度下滑，比上个月又低了5%",
							"同类型的酒店房价比我们低，可降低房价进行促销",
							"注重促销活动的沟通方案，信息传递要及时",
							"可与旅行社和用车平台结成战略性伙伴关系",
							"套餐活动和积分兑奖可能是这次促销上的重点推荐",
							"会务营销或成为这次淡季里的卖点之一",
							"调动酒店的成员参与促销，激励措施要合理"
						]
					}
					hotelObj.showQuestionDialogue(1);
				}
			}
		},
		"qst8": {
			pageRules: {
				"default": function(hotelObj, qstId, answer) {
					//导师问题2
					hotelObj.optionSelectedIndex = -1;

					if(hotelObj.solutionPart.episode == 0 || hotelObj.solutionPart.episode == 1) {
						hotelObj.currentQuestion = {
							id: 9,
							title: "时间就在你收集与分析信息的时候悄悄溜走了，现在到了要制定方案的时候，看看你会怎么做吧。",
							type: "单选题",
							sub: 1,
							options: [
								"【咬笔杆】我果然是天才，现在已经有了好多想法，赶快写下来先！",
								"哎，立娜、高朗，你们有空吗？我正好想和你们一起聊聊酒店促销的事儿。",
								"【自信】方案在手，天下我有，促销方案我基本有眉目了！"
							]
						}
					} else {
						hotelObj.currentQuestion = {
							id: 29,
							title: "时间就在你收集与分析信息的时候悄悄溜走了，现在到了要制定方案的时候，看看你会怎么做吧。",
							type: "单选题",
							sub: 1,
							options: [
								"哎，立娜、小季，你们有空吗？我正好想和你们一起聊聊黎启的事儿。",
								"唔，好记性不如烂笔头，把手里的信息整整，弄几个方案出来先！",
								"方案在手，天下我有，黎启的事儿我已经想到办法了！"
							]
						}
					}

					$("#wrap").hide().addClass("bg3").fadeIn();
					$("#mindyicon").show();
					$("#tipText").html(hotelObj.currentQuestion.title);
					$("#choiceTip").show();
					$(".choice-title").html("");
					$("#single-choice").hide();
					$("#single-choice").addClass("single-choice-small");
					$("#single-choice").show();
				}
			}
		},
		"qst9": {
			pageRules: {
				"default": function(hotelObj, qstId, answer) {
					$("#mindyicon").hide();
					$("#choiceTip").hide();
					$("#single-choice").hide();
					if(answer == 0 || answer == 1) {
						hotelObj.currentIndex = 31;
						hotelObj.onUnlock();
						return;
					} else {
						$("#wrap").hide().addClass("bg4").show();
						hotelObj.currentIndex = 32;
						hotelObj.onUnlock();
						return;
					}
				}
			}
		},
		"qst17": {
			pageRules: {
				"default": function(hotelObj, qstId, answer) {
					hotelObj.optionSelectedIndex = 1;
					hotelObj.currentQuestion = {
						id: 18,
						title: "苦思冥想过后，你已经挑选好了需要的信息，请为它们排个序吧。",
						type: "排序题",
						sub: 4,
						options: [
							"客户满意度下滑，比上个月又低了5%",
							"大数据时代要为消费者提供时尚、贴心、健康、快乐、舒适的酒店住宿服务",
							"建立所有入住顾客的资料库，提供个性化服务",
							"提升酒店服务人员的个人形象和服务素质",
							"加强酒店的安全，提升服务人员的意识，部署技术手段保障客户人身安全",
							"年轻人更喜欢健身、社交的空间，要重视这方面需求",
							"需要考虑酒店数字化、智能化的服务体验的实施可能性"
						]
					}
					hotelObj.showQuestionDialogue(1);
				}
			}
		},
		"qst18": {
			pageRules: {
				"default": function(hotelObj, qstId, answer) {
					hotelObj.optionSelectedIndex = -1;
					hotelObj.currentQuestion = {
						id: 9,
						title: "时间就在你收集与分析信息的时候悄悄溜走了，现在到了要制定方案的时候，看看你会怎么做吧。",
						type: "单选题",
						sub: 1,
						options: [
							"【咬笔杆】我果然是天才，现在已经有了好多想法，赶快写下来先！",
							"哎，立娜、高朗，你们有空吗？我正好想和你们一起聊聊酒店促销的事儿。",
							"【自信】方案在手，天下我有，促销方案我基本有眉目了！"
						]
					}

					$("#wrap").hide().addClass("bg3").fadeIn();
					$("#mindyicon").show();
					$("#tipText").html(hotelObj.currentQuestion.title);
					$("#choiceTip").show();
					$(".choice-title").html("");
					$("#single-choice").hide();
					$("#single-choice").addClass("single-choice-small");
					$("#single-choice").show();
				}
			}
		},
		"qst27": {
			pageRules: {
				"default": function(hotelObj, qstId, answer) {
					hotelObj.optionSelectedIndex = 1;
					hotelObj.currentQuestion = {
						id: 28,
						title: "苦思冥想过后，你已经挑选好了需要的信息，请为它们排个序吧。",
						type: "排序题",
						sub: 4,
						options: [
							"员工觉得自己的性格并不适合团队的工作风格",
							"跨部门同事建议好好考察问题员工，别太优柔寡断",
							"下属马上要休产假，会务团队的压力持续增加",
							"VVIP客户团的接待对酒店来说很重要",
							"请辞下属的主管反映他工作情况尚可，平时比较努力",
							"采取加薪的方式是留住员工的激励手段之一",
							"员工的问题要尽快解决，不影响团队士气"
						]
					}
					hotelObj.showQuestionDialogue(1);
				}
			}
		},
		"qst28": {
			pageRules: {
				"default": function(hotelObj, qstId, answer) {
					hotelObj.optionSelectedIndex = -1;
					hotelObj.currentQuestion = {
						id: 29,
						title: "时间就在你收集与分析信息的时候悄悄溜走了，现在到了要制定方案的时候，看看你会怎么做吧。",
						type: "单选题",
						sub: 1,
						options: [
							"哎，立娜、小季，你们有空吗？我正好想和你们一起聊聊黎启的事儿。",
							"唔，好记性不如烂笔头，把手里的信息整整，弄几个方案出来先！。",
							"方案在手，天下我有，黎启的事儿我已经想到办法了！"
						]
					}
					$("#wrap").hide().addClass("bg3").fadeIn();
					$("#mindyicon").show();
					$("#tipText").html(hotelObj.currentQuestion.title);
					$("#choiceTip").show();
					$(".choice-title").html("");
					$("#single-choice").hide();
					$("#single-choice").addClass("single-choice-small");
					$("#single-choice").show();
				}
			}
		},
		"qst29": {
			pageRules: {
				"default": function(hotelObj, qstId, answer) {
					$("#mindyicon").hide();
					$("#choiceTip").hide();
					$("#single-choice").hide();

					if(answer == 0 || answer == 1) {
						hotelObj.currentIndex = 31;
						hotelObj.onUnlock();
						return;
					} else {
						hotelObj.currentIndex = 32;
						hotelObj.onUnlock();
						return;
					}
				}
			}
		},
		"qst30": {
			pageRules: {
				"default": function(hotelObj, qstId, answer) {
					$("#step6-solution-tab").hide();
					$("#step6-solution-content").hide();
					$("#step6-solution-button").hide();
					hotelObj.currentIndex = 32;
					hotelObj.onUnlock();
				}
			}
		},
		"qst31": {
			pageRules: {
				"default": function(hotelObj, qstId, answer) {
					$("#step6-solution-tab").hide();
					$("#step6-solution-content").hide();
					$("#step6-solution-button").hide();
					hotelObj.currentIndex = 32;
					hotelObj.onUnlock();
				}
			}
		},
		"qst32": {
			pageRules: {
				"default": function(hotelObj, qstId, answer) {
					$("#step6-solution-tab").hide();
					$("#step6-solution-content").hide();
					$("#step6-solution-button").hide();
					hotelObj.currentIndex = 32;
					hotelObj.onUnlock();
				}
			}
		},
		"qst33": {
			pageRules: {
				"default": function(hotelObj, qstId, answer) {
					hotelObj.optionSelectedIndex = parseInt(answer);
					hotelObj.currentIndex = 34;
					hotelObj.onUnlock();
				}
			}
		},
		"qst34": {
			pageRules: {
				"default": function(hotelObj, qstId, answer) {
					hotelObj.optionSelectedIndex = parseInt(answer);
					hotelObj.currentIndex = 34;
					hotelObj.onUnlock();
				}
			}
		},
		"qst35": {
			pageRules: {
				"default": function(hotelObj, qstId, answer) {
					hotelObj.optionSelectedIndex = parseInt(answer);
					hotelObj.currentIndex = 34;
					hotelObj.onUnlock();
				}
			}
		},
		"qst36": {
			pageRules: {
				"default": function(hotelObj, qstId, answer) {
					if(answer > -1) {
						//单选题
						hotelObj.optionSelectedIndex = parseInt(answer);
						hotelObj.currentIndex = 35;
						hotelObj.onUnlock();
					}

				}
			}
		},
		"qst37": {
			pageRules: {
				"default": function(hotelObj, qstId, answer) {
					if(answer > -1) {
						//单选题
						hotelObj.optionSelectedIndex = parseInt(answer);
						hotelObj.currentIndex = 35;
						hotelObj.onUnlock();
					}

				}
			}
		},
		"qst38": {
			pageRules: {
				"default": function(hotelObj, qstId, answer) {
					if(answer > -1) {
						//单选题
						hotelObj.optionSelectedIndex = parseInt(answer);
						hotelObj.currentIndex = 35;
						hotelObj.onUnlock();
					}

				}
			}
		},
		"qst39": {
			pageRules: {
				"default": function(hotelObj, qstId, answer) {
					hotelObj.lock = true;
					$("#mindyicon").fadeOut();
					$("#choiceTip").fadeOut();
					$("#single-choice").hide();

					if(answer == 0)
						hotelObj.currentIndex = 99;
					else if(answer == 1 || answer == 2 || answer == 3) {
						hotelObj.currentQuestion.id = 0;
						hotelObj.currentIndex = 60;
					}
					hotelObj.onUnlock();

				}
			}
		},
		"qst40": {
			pageRules: {
				"default": function(hotelObj, qstId, answer) {
					hotelObj.lock = true;
					$("#mindyicon").fadeOut();
					$("#choiceTip").fadeOut();
					$("#single-choice").hide();

					if(answer == 0)
						hotelObj.currentIndex = 99;
					else if(answer == 1 || answer == 2 || answer == 3) {
						hotelObj.currentQuestion.id = 0;
						hotelObj.currentIndex = 60;
					}
					hotelObj.onUnlock();

				}
			}
		},
		"qst41": {
			pageRules: {
				"default": function(hotelObj, qstId, answer) {
					hotelObj.lock = true;
					$("#choiceTip").fadeOut();
					$("#single-choice").hide();

					if(answer == 0)
						hotelObj.currentIndex = 99;
					else if(answer == 1 || answer == 2 || answer == 3) {
						hotelObj.currentQuestion.id = 0;
						hotelObj.currentIndex = 60;
					}
					hotelObj.onUnlock();

				}
			}
		},
		"qst67": {
			pageRules: {
				"default": function(hotelObj, qstId, answer) {
					$("#single-choice").hide();
            		hotelObj.gotoCreateReport();
				}
			}
		},
		"qst76": {
			pageRules: {
				"default": function(hotelObj, qstId, answer) {
					$("#single-choice").hide();
            		hotelObj.gotoCreateReport();
				}
			}
		},
		"qst84": {
			pageRules: {
				"default": function(hotelObj, qstId, answer) {
					hotelObj.lock = true;
					$("#single-choice").hide();
            		hotelObj.gotoCreateReport();
				}
			}
		},
		"qstdefault": {
			pageRules: {
				"default": function(hotelObj, qstId) {
					hotelObj.currentQuestion.id = qstId;
					hotelObj.selectedMutliChoice = {};
					hotelObj.optionSelectedIndex = -1;
					hotelObj.currentIndex = 62;
					hotelObj.onUnlock();
				}
			}
		}

	};

	constructor() {

	}

	recoverState(castHotel: any, qstId: number, answer: String) {
		//console.log("into");
		this.revoverBackground(qstId);
		var qstItem;
		var recoverFunc;
		
		castHotel.firstVist = false;
		castHotel.currentQuestion.id = qstId;
		castHotel.selectedMutliChoice[1] == true;
		castHotel.selectedMutliChoice[0] == true;
		castHotel.currentIndex = 31;
		castHotel.lock = true;
		//特殊处理
//		if(([6,9,19,29,30,31,32,33,34,35].indexOf(qstId) >-1)){
//			castHotel.showfakeIcon();
//		}
		castHotel.SKIPStagedOne = false;
		if([60, 61, 62, 63, 64, 65, 66, 70, 71, 72, 73, 74, 75, 80, 81, 82, 83].indexOf(qstId) > -1) {
			recoverFunc = this.questionList["qstdefault"].pageRules["default"];
			recoverFunc(castHotel, qstId, answer);
		} else {
			qstItem = this.questionList["qst" + qstId];
			recoverFunc = qstItem.pageRules[answer+""];
			if(!recoverFunc) {
				recoverFunc = qstItem.pageRules["default"];
			}
			recoverFunc(castHotel, qstId, answer);
		}

	}

	revoverBackground(qstId: number) {
		//非第一次进入,去除首屏提示
		$("#shade").hide();
		//console.log("qstId:"+qstId);
		let wrapObj = $("#wrap");
		if([1, 2, 3].indexOf(qstId) > -1) {
            //console.log("00000");
			wrapObj.addClass("bg2");
		}
		if([4, 5, 6, 7, 8, 18, 28].indexOf(qstId) > -1) {
            //console.log("111222333");
			wrapObj.addClass("bg3");
		}
		if([9,19,29,30,31,32, 33, 36, 39, 60, 61, 62, 63, 64, 65, 66, 67, 70, 71, 72, 73, 74, 75, 76, 80, 81, 82, 83].indexOf(qstId) > -1) {
            //console.log("11111");
			wrapObj.addClass("bg4");
		}
		else if (qstId>29){
			//console.log("22222");
            wrapObj.addClass("bg4");
        }
	}

}


// WEBPACK FOOTER //
// ./src/app/case-practice-hotel/question-config.ts